/**
 * Initializes the alert service for the mobile app by setting up an AlertManager handler.
 * Once initialized, alerts can be displayed anywhere in the app by calling alertService.alert()
 */

import { useRef } from 'react';

import { IAlertHandler, IMobileAlertParams, alertService } from '@webtrader/core/services/alert';

import { AlertManager } from '@/components/Alert/Manager';
import { usePortalContext } from '@/components/Portal/PortalContext';
import { removeGate } from '@/components/Portal/PortalUtil';

export const useInitMobileAlert = () => {
  const { gates } = usePortalContext();
  const refreshHandler = useRef(true); // Use ref to avoid re-render

  const mobileAlert: IAlertHandler = {
    alert: (params: IMobileAlertParams) => {
      const { type, message, title, id, noButton, absoluteAlert, onAfterCancel, onBeforeCancel } = params;
      if (gates['alert']) {
        removeGate('alert');
      }
      refreshHandler.current = !refreshHandler.current;
      AlertManager().alert({
        type,
        refresh: refreshHandler.current,
        message,
        title,
        id,
        noButton,
        absoluteAlert,
        onAfterCancel,
        onBeforeCancel
      });
    }
  };

  alertService.setAlertHandler(mobileAlert);
};
